export default __webpack_public_path__ + "static/media/com.387f21de.jpg";